/**
 * Endpoint to send 1DS telemetry events to. Includes public and special environments endpoints.
 */
export var OneDSEndpoint;
(function (OneDSEndpoint) {
    /**
     * US Department of Defense endpoint (Pathfinder)
     */
    OneDSEndpoint["USGOV_DOD"] = "https://pf.events.data.microsoft.com/OneCollector/1.0/";
    /**
     * US Department of Justice endpoint (Trailblazer)
     */
    OneDSEndpoint["USGOV_DOJ"] = "https://tb.events.data.microsoft.com/OneCollector/1.0/";
    /**
     * Public endpoint
     */
    OneDSEndpoint["PUBLIC"] = "https://browser.events.data.microsoft.com/OneCollector/1.0/";
    /**
     * Customer content
     */
    OneDSEndpoint["CUSTOMER_CONTENT"] = "https://office-c.events.data.microsoft.com/OneCollector/1.0/";
    /**
     * EUDB endpoint
     */
    OneDSEndpoint["EUDB"] = "https://eu-office.events.data.microsoft.com/OneCollector/1.0/";
})(OneDSEndpoint || (OneDSEndpoint = {}));
//# sourceMappingURL=DataModels.js.map